export default function () {
  return [
    {
      path: '/mine',
      name: 'Mine',
      component: () => import(/* webpackChunkName: "mine" */ '@components/UserDetail'),
      meta: {
        title: 'Mine',
        needLogin: true
      }
    },
    {
      path: '/myWallet',
      name: 'NyWallet',
      component: () => import(/* webpackChunkName: "myWallet" */ '@views/mine/myWallet'),
      meta: {
        title: 'NyWallet',
        needLogin: true
      }
    },
    {
      path: '/walletSetting',
      name: 'WalletSetting',
      component: () => import(/* webpackChunkName: "myWallet" */ '@views/mine/walletSetting'),
      meta: {
        title: 'WalletSetting',
        needLogin: true
      }
    },
    {
      path: '/history',
      name: 'History',
      component: () => import(/* webpackChunkName: "history" */ '@views/mine/history'),
      meta: {
        title: 'History',
        needLogin: true
      }
    },
    {
      path: '/task',
      name: 'Task',
      component: () => import(/* webpackChunkName: "task" */ '@views/mine/task'),
      meta: {
        title: 'Task',
        needLogin: true
      }
    },
    {
      path: '/setting',
      name: 'Setting',
      component: () => import(/* webpackChunkName: "setting" */ '@views/mine/setting'),
      meta: {
        title: 'Setting',
        needLogin: true
      }
    },
    {
      path: '/accountSafe',
      name: 'AccountSafe',
      component: () => import(/* webpackChunkName: "setting" */ '@views/mine/setting/userInfo'),
      meta: {
        title: 'AccountSafe',
        needLogin: true
      }
    },
    {
      path: '/userInfoEdit',
      name: 'UserInfoEdit',
      component: () => import(/* webpackChunkName: "userInfoEdit" */ '@views/mine/userInfoEdit'),
      meta: {
        title: 'UserInfoEdit',
        needLogin: true
      }
    },
    {
      path: '/editUserInfoPage',
      name: 'EditUserInfoPage',
      component: () => import(/* webpackChunkName: "userInfoEdit" */ '@views/mine/userInfoEdit/editUserInfoPage'),
      meta: {
        title: 'EditUserInfoPage',
        needLogin: true
      }
    },
    {
      path: '/modifyLoginPassword',
      name: 'ModifyLoginPassword',
      component: () => import(/* webpackChunkName: "setting" */ '@views/mine/setting/userInfo/modifyLoginPassword'),
      meta: {
        title: 'ModifyLoginPassword',
        needLogin: true
      }
    },
    {
      path: '/privacySetting',
      name: 'PrivacySetting',
      component: () => import(/* webpackChunkName: "setting" */ '@views/mine/setting/privacy'),
      meta: {
        title: 'PrivacySetting',
        needLogin: true
      }
    },
    {
      path: '/touristBind',
      name: 'TouristBind',
      component: () => import(/* webpackChunkName: "setting" */ '@views/mine/setting/touristBind'),
      meta: {
        title: 'PrivacySetting',
        needLogin: true
      }
    },
    {
      path: '/deposit',
      name: 'Deposit',
      component: () => import(/* webpackChunkName: 'deposit' */ '@views/mine/deposit'),
      meta: {
        title: 'Deposit',
        needLogin: true
      }
    },
    {
      path: '/depositRecords',
      name: 'DepositRecords',
      component: () => import(/* webpackChunkName: 'deposit' */ '@views/mine/depositRecords'),
      meta: {
        title: 'DepositRecords',
        needLogin: true
      }
    },
    {
      path: '/goldCoinRecords',
      name: 'GoldCoinRecords',
      component: () => import(/* webpackChunkName: 'deposit' */ '@views/mine/goldCoinRecords'),
      meta: {
        title: 'DepositRecords',
        needLogin: true
      }
    },
    {
      path: '/withdrawWays',
      name: 'WithdrawWays',
      component: () => import(/* webpackChunkName: 'withdrawWays' */ '@views/mine/withdrawWays'),
      meta: {
        title: 'WithdrawWays',
        needLogin: true
      }
    },
    {
      path: '/withdraw',
      name: 'Withdraw',
      component: () => import(/* webpackChunkName: 'withdraw' */ '@views/mine/withdraw'),
      meta: {
        title: 'Withdraw',
        needLogin: true
      }
    },
    {
      path: '/withdrawPsd',
      name: 'WithdrawPsd',
      component: () => import(/* webpackChunkName: 'addWithdrawPsd' */ '@views/mine/withdrawPsd'),
      meta: {
        title: 'AddWithdrawPsd',
        needLogin: true
      }
    },
    {
      path: '/modifyWithdrawInfo',
      name: 'ModifyWithdrawInfo',
      component: () => import(/* webpackChunkName: 'withdraw' */ '@views/mine/modifyWithdrawInfo'),
      meta: {
        title: 'ModifyWithdrawInfo',
        needLogin: true
      }
    },
    {
      path: '/friendFanFollow',
      name: 'FriendFanFollow',
      component: () => import(/* webpackChunkName: 'withdraw' */ '@views/mine/friendFanFollow'),
      meta: {
        title: 'FriendFanFollow',
        needLogin: true
      }
    },
    {
      path: '/bill',
      name: 'Bill',
      component: () => import(/* webpackChunkName: 'withdraw' */ '@views/mine/bill'),
      meta: {
        title: 'Bill',
        needLogin: true
      }
    },
    {
      path: '/vipCenter',
      name: 'vipCenter',
      component: () => import(/* webpackChunkName: 'withdraw' */ '@views/mine/vipCenter'),
      meta: {
        title: 'vipCenter',
        needLogin: true
      }
    },
    {
      path: '/signCenter',
      name: 'SignCenter',
      component: () => import(/* webpackChunkName: 'withdraw' */ '@views/mine/signCenter'),
      meta: {
        title: 'signCenter',
        needLogin: true
      }
    },
    {
      path: '/fansGroup',
      name: 'FansGroup',
      component: () => import(/* webpackChunkName: 'fansGroup' */ '@views/mine/fansGroup'),
      meta: {
        title: 'fansGroup',
        needLogin: true
      }
    },
    {
      path: '/fansGroupRules',
      name: 'FansGroupRules',
      component: () => import(/* webpackChunkName: 'fansGroup' */ '@views/mine/fansGroup/rules'),
      meta: {
        title: 'fansGroupRules',
        needLogin: true
      }
    },
    {
      path: '/memberRecharge',
      name: 'MemberRecharge',
      component: () => import('@views/mine/memberRecharge/recharge/index.vue'),
      meta: {
        title: 'memberRecharge',
        needLogin: true
      }
    },
    {
      path: '/promotion',
      name: 'Promotion',
      component: () => import('../../views/mine/userInvite/promotion'),
      meta: {
        title: 'promotion',
        needLogin: true
      }
    },
    {
      path: '/createCenter',
      name: 'CreatCenter',
      component: () => import('@views/mine/createManagement/createCenter/index.vue'),
      meta: {
        title: 'createCenter',
        needLogin: true
      }
    },
    {
      path: '/works',
      name: 'Works',
      component: () => import('@views/mine/createManagement/works/index.vue'),
      meta: {
        title: 'works',
        needLogin: true
      }
    },
    {
      path: '/fanList',
      name: 'FanClubList',
      component: () => import('@views/mine/fanClub/fanClubList/index.vue'),
      meta: {
        title: 'fanList',
        needLogin: true
      }
    },
    {
      path: '/fanAdd',
      name: 'FanClubAdd',
      component: () => import('@views/mine/fanClub/fanClubCreate/index.vue'),
      meta: {
        title: 'fanAdd',
        needLogin: true
      }
    },
    {
      path: '/ranking',
      name: 'Ranking',
      component: () => import('@views/mine/createManagement/ranking/index.vue'),
      meta: {
        title: 'ranking',
        needLogin: true
      }
    },
    {
      path: '/invite',
      name: 'Invite',
      component: () => import('@views/mine/userInvite/invite/index.vue'),
      meta: {
        title: 'invite',
        needLogin: true
      }
    },
    {
      path: '/profitDetails',
      name: 'ProfitDetails',
      component: () => import('@views/mine/userInvite/profitDetails/index.vue'),
      meta: {
        title: 'profitDetails',
        needLogin: true
      }
    },
    {
      path: '/myBuy',
      name: 'MyBuy',
      component: () => import('@views/mine/myBuy/index.vue'),
      meta: {
        title: 'myBuy',
        needLogin: true
      }
    },
    {
      path: '/drivingGroup',
      name: 'DrivingGroup',
      component: () => import('@views/mine/drivingGroup/index.vue'),
      meta: {
        title: 'drivingGroup',
        needLogin: true
      }
    },
    {
      path: '/inviteHistory',
      name: 'InviteHistory',
      component: () => import('@views/mine/userInvite/inviteHistory/index.vue'),
      meta: {
        title: 'inviteHistory',
        needLogin: true
      }
    },
    {
      path: '/userMessage',
      name: 'UserMessage',
      component: () => import('@views/mine/userMessage/index.vue'),
      meta: {
        title: 'UserMessage',
        needLogin: true
      }
    },
    {
      path: '/msgDetail',
      name: 'MsgDetail',
      component: () => import('@views/mine/userMessage/msgDetail/index.vue'),
      meta: {
        title: 'msgDetail',
        needLogin: true
      }
    }
  ];
};
